import {ActivatedRoute} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {WizardPageBaseComponent} from './wizard-page-base.component';

@Component({template: ''})
export abstract class WizardListPageBaseComponent<T> extends WizardPageBaseComponent<T> implements OnInit {

  public selectedIndex = -1;
  public maxAllowed = 1000;
  public showMaxLimitHint = false;

  protected constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  public toggleSelect(i: number): void {
    if (this.selectedIndex !== i) {
      this.selectedIndex = i;
    } else {
      this.selectedIndex = -1;
    }
  }

}
